import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

import { Button } from "@novaescola/eva-react-v2";

import { AccountApi } from "../../../api/account/account.api";

const COOKIE_NAME = "ane-confirmation-block_6d19a3d628";
const COOKIE_REMATRICULA_NAME = "ane-confirmation-block_bfef93f29c";
const COOKIE_CLOSE_NAME = "ane-confirmation-block_close";
const OCUPACOES = {
  AUXILIAR_CLASSE: {
    text: "Auxiliar de classe/Monitor(a) de classe",
    event: "auxiliar/monitor",
  },
  ESTAGIARIO: { text: "Estagiário(a)", event: "estagiário" },
  PROFESSOR: { text: "Professor(a)", event: "professor" },
  COORDENADOR_PEDAGOGICO: {
    text: "Coordenador(a) Pedagógico(a)",
    event: "coordenador",
  },
  ORIENTADOR_EDUCACIONAL: {
    text: "Orientador(a) Educacional",
    event: "orientador",
  },
  DIRETOR: { text: "Diretor(a)/Vice-diretor(a)", event: "diretor/vice" },
  SECRETARIO_EDUCACAO: {
    text: "Secretário(a) de Educação",
    event: "secretário ed.",
  },
  SUB_SECRETARIO_EDUCACAO: {
    text: "Sub Secretário(a) de Educação",
    event: "sub secretário ed.",
  },
  TECNICO_SECRETARIA: {
    text: "Técnico(a) de Secretaria",
    event: "técnico secretaria",
  },
  ESTUDANTE: { text: "Estudante", event: "estudante" },
  P_M_R_POR_ALUNO: {
    text: "Mãe, pai ou responsável por estudante",
    event: "pai/mãe/responsável",
  },
  OUTRA: { text: "Outra", event: "outro" },
};

export const ConfirmationBlockOcupacao = ({ user, fetchUser }) => {
  const [hidden, setHidden] = useState(true);
  const [ocupacao, setOcupacao] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [accessToken, setAccessToken] = useState("");

  useEffect(() => {
    const token = Cookies.get("Bearer");

    setAccessToken(token);
    setHidden(false);

    if (user.ocupacao) setOcupacao(user.ocupacao);

    sendEventToDataLayer(
      "block_visualization",
      "JORNALISMO: matrícula - complementação de cadastro - ocupação - bloco visualizado"
    );
  }, []);

  const sendEventToDataLayer = (event, label) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, label });
  };

  const handleSubmit = async () => {
    setSubmitted(true);

    const response = await AccountApi.updateUserOcupacao(accessToken, ocupacao);

    if (!response) {
      const expires = new Date();
      expires.setUTCDate(expires.getUTCDate() + 1);

      Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
      setHidden(true);

      return;
    }

    fetchUser(accessToken);

    const dtUltimaModificacao = new Date(user.dtUltimaModificacao);

    const lastYear = new Date();
    lastYear.setMonth(lastYear.getMonth() - 12);

    const finalEventLabel =
      user.ocupacao && dtUltimaModificacao < lastYear ? " - rematrícula" : "";

    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - ocupação - botão enviar${finalEventLabel}`
    );
    sendEventToDataLayer(
      "confirmation_block",
      `JORNALISMO: matrícula - complementação de cadastro - ocupação - ${OCUPACOES[ocupacao].event}`
    );

    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);

    Cookies.set(COOKIE_NAME, "true", { expires });

    if (user.ocupacao && dtUltimaModificacao < lastYear)
      Cookies.set(COOKIE_REMATRICULA_NAME, "true", { expires });

    setHidden(true);
  };

  const handleClose = () => {
    const expires = new Date();
    expires.setUTCDate(expires.getUTCDate() + 1);

    Cookies.set(COOKIE_CLOSE_NAME, "true", { expires });
    setHidden(true);

    sendEventToDataLayer(
      "confirmation_block",
      "JORNALISMO: matrícula - complementação de cadastro - ocupação - botão sair"
    );
  };

  if (hidden) return null;

  return (
    <div className="eva-bg-inst-50 eva-mb-07 eva-pr-05 eva-pl-05 eva-pb-05 eva-pt-05 confirmation-block">
      <div className="eva-mb-03 confirmation-block-title">
        <i className="far fa-circle-question eva-mr-03" />
        Qual é a sua ocupação?
      </div>
      <div className="confirmation-block-options-select">
        <label htmlFor="ocupacao-select" className="eva-label">
          Ocupação *
        </label>
        <div className="eva-select-wrapper">
          <select
            id="ocupacao-select"
            name="select"
            className="eva-select"
            value={ocupacao}
            onChange={(event) => setOcupacao(event.target.value)}
          >
            <option disabled value="">
              Selecione uma opção
            </option>
            {Object.entries(OCUPACOES).map(([value, { text }]) => (
              <option value={value} key={`ocupacao-option-${value}`}>
                {text}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="eva-mt-05">
        <Button
          type="button"
          variant="primary"
          size="small"
          disabled={submitted || !ocupacao}
          onClick={handleSubmit}
        >
          Enviar
        </Button>
      </div>
      <button
        type="button"
        aria-label="Fechar"
        className="eva-cursor-pointer confirmation-block-close"
        onClick={() => handleClose()}
      >
        <i className="far fa-times"></i>
      </button>
    </div>
  );
};
